export default __webpack_public_path__ + "static/media/bg5.ef60603d.jpg";